const features = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '零弹窗、零贴片、零插屏广告，打造最纯净的观影环境。从打开网站到影片结束，没有任何商业信息打扰你的观影体验。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '多线路智能负载均衡 + 自研播放引擎，自动选择最优CDN节点。高清画质也能丝滑播放，告别卡顿和缓冲等待。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '海量资源库',
    desc: '覆盖动作、喜剧、悬疑、科幻、动画等全品类，从院线新片到经典老片，从国产佳作到海外巨制，28000+部影片持续更新中。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">为什么选择被窝影院</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">三大核心优势，重新定义在线观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 text-center transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-5 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}